import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Lists AI deal simulations, newest first.
 * Response is `{ simulations, nextLastSeen }` — pass `nextLastSeen` back as
 * `lastSeen` for the next page; it is `null` once there is nothing left.
 * `organizationId` is optional (omit to list across every org).
 */
const getSimulations = (
  organizationId,
  limit,
  lastSeen,
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get('/ads/admin/simulations', {
            params: {
              'request-id': reqId,
              limit: limit || 20,
              ...(organizationId ? { organizationId } : {}),
              ...(lastSeen ? { lastSeen } : {}),
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            if (typeof callback === 'function')
              callback({
                simulations: response?.data?.simulations || [],
                nextLastSeen: response?.data?.nextLastSeen || null,
              });
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch simulations');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to fetch simulations',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch simulations');
    }
  };
};

export default getSimulations;
